import { RouterModule, Routes } from '@angular/router';
import { UserComponent } from './user.component';
import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserService } from './user.service';
import { MatButtonModule } from '@angular/material/button';
import { userReducer } from 'app/_store/userStore/user.reducer';
import { UserEffects } from 'app/_store/userStore/user.effects';

const routes: Routes = [{ path: 'testUser', component: UserComponent }];

@NgModule({
  declarations: [UserComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    AsyncPipe,
    MatButtonModule,
    StoreModule.forFeature('user', userReducer), // Feature slice
    EffectsModule.forFeature([UserEffects]) // Feature effects
  ],
  exports: [UserComponent],
  providers: [UserService]
})
export class UserModule {}
